import { Autocomplete, Box, Button, Checkbox, FormControl, FormControlLabel, Grid, InputLabel, MenuItem, Select, Stack, TextField } from '@mui/material';
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom'
import CancelModal from '../../components/Modal/CancelModal';
import DeleteModal from '../../components/Modal/DeleteModal';
import UserRolesSelect from '../../components/UserRolesSelect/UserRolesSelect';
import SelectOrganisation from '../../components/Select/SelectOrganisation'
import { deleteAdminAccount, getOfficesData, resetResponseState, unsetLoading } from '../../store/appAction';
import { EDIT, SELF_EDIT, CREATE } from '../../constants/modes';
import _ from 'lodash';
import { matchSorter } from 'match-sorter';
import { AgcAlert } from '../Alerts/AgcAlert'

const AccountForm = props => {
    const {
        values: {
            type,
            email,
            firstName,
            lastName,
            organisationName,
            organisationId,
            office: officeName,
            officeId,
            active,
            newsletter
        },
        errors,
        touched,
        setFieldValue,
        handleSubmit,
        handleBlur,
        handleChange,
        handleReset,
        resetForm,
        role,
        mode,
    } = props;
    const dispatch = useDispatch();
    let navigate = useNavigate();

    const [modalOpen, setModalOpen] = useState(false);
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);

    const [offices, setOffices] = useState([]);
    const [office, setOffice] = useState(null);

    const currentOffices = useSelector(state => state.common.offices);

    const { successMsg, errorMsg } = useSelector(state => state.common);

    const filterOptionsForOffice = (options,{ inputValue }) => {
        if( options && inputValue){
            return matchSorter(options, inputValue, {keys: ['id', 'officeName']});
        }else if (options){
            return options
        }
        return []
    }
    useEffect(() => {
        return () => {
            resetForm();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onAlertClose = () => {
        if (successMsg || errorMsg) {
            dispatch(unsetLoading());
            if (successMsg && mode !== EDIT) {
                handleReset();
                setOffice(null);
            }
            dispatch(resetResponseState());
        }
    };

    useEffect(() => {
        setOffices(currentOffices);
        (mode === EDIT) && (currentOffices?.length > 0) &&
            officeId && setOffice(_.find(currentOffices, { id: officeId }) || null);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentOffices]);

    useEffect(() => {
        if (organisationId)
            dispatch(getOfficesData({ organisationId }))
        else {
            setFieldValue("officeId", "");
            setOffices([]);
            setOffice(null);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [organisationId]);

    useEffect(() => {
        setOffice(_.find(currentOffices, { id: officeId }) || null);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [officeId]);

    const handleCancelModalResponse = (positiveResponse) => {
        setModalOpen(false);
        if (positiveResponse) {
           window.scrollY = 0;
            handleReset();
            if (mode !== EDIT) {
                setOffice(null);
            }
        }
    }

    const handleDeleteModalResponse = (positiveResponse) => {
        setDeleteModalOpen(false);
        if (positiveResponse) {
           window.scrollY = 0;
            handleReset();
            setOffice(null);
            dispatch(deleteAdminAccount());
            handleBackResponse();
        }
    }

    const handleBackResponse = () => {
        navigate('/admin/account/list');
    }

    const fetchOptions = (data, nameKey) => {
        if (mode === SELF_EDIT) {
            switch (nameKey) {
                case 'officeName':
                    return [
                        <MenuItem id={officeId} key={officeId} value={officeId} >
                            {officeName}
                        </MenuItem>
                    ];
                default:
                    return [];
            }
        }
        return (
            Object.entries(data || []).map(([optionId, optionData]) => (
                <MenuItem id={optionData.id} key={optionData.id} value={optionData.id} >
                    {optionData[nameKey]}
                </MenuItem>
            )));
    }

    // TODO when user is consultant then lock the organisation as readonly 
    // and if the user is only part of one office lock the office too.
    return (
            <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 3, p: 1, ml: 20, pr: 30 }}>
                <Grid
                    spacing={1}
                    container
                    direction="column"
                    justifyContent="space-evenly"
                    alignItems="stretch"
                >
                    <Grid item xs={12} sm={6}>
                        <FormControl fullWidth error={Boolean(errors.type)}>
                            <InputLabel id="type-select">Type</InputLabel>
                            <UserRolesSelect
                                disabled={mode === SELF_EDIT }
                                autoComplete="type"
                                fullWidth
                                name="type"
                                label="Type"
                                id="type"
                                labelId="type-select"
                                onChange={handleChange}
                                value={type}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            id="email"
                            name="email"
                            autoComplete="email"
                            label="Email Address"
                            helperText={touched.email ? errors.email : ""}
                            error={Boolean(touched.email ? errors.email : false)}
                            value={email}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            id="firstName"
                            name="firstName"
                            autoComplete="given-name"
                            label="First Name"
                            helperText={touched.firstName ? errors.firstName : ""}
                            error={Boolean(touched.firstName ? errors.firstName : false)}
                            value={firstName}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            id="lastName"
                            name="lastName"
                            autoComplete="given-name"
                            label="Last Name"
                            helperText={touched.lastName ? errors.lastName : ""}
                            error={Boolean(touched.lastName ? errors.lastName : false)}
                            value={lastName}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                            <SelectOrganisation 
                                organisationId={organisationId}
                                organisationName={organisationName}
                                disabled={mode === SELF_EDIT}
                                onChange={(e, value) => {
                                        setFieldValue("organisationId", value?.id || "");
                                        setFieldValue("officeId", "");
                                        setOffices([]);
                                        setOffice(null);
                                    }}
                                errors={errors}
                                touched={touched}/>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        {mode === SELF_EDIT ?
                            <FormControl fullWidth error={Boolean(errors.officeId)}>
                                <InputLabel id="officeId-select">Office</InputLabel>
                                <Select
                                    disabled={mode === SELF_EDIT}
                                    fullWidth
                                    name="officeId"
                                    label="Office"
                                    id="officeId"
                                    labelId="officeId-select"
                                    onChange={handleChange}
                                    value={officeId}
                                >
                                    {fetchOptions(offices, 'officeName', 'office')}
                                </Select>
                            </FormControl> :
                            <Autocomplete
                                id="office-autocomplete"
                                disablePortal
                                value={office}
                                options={offices}
                                getOptionLabel={(office) => `${office?.officeName}`}
                                isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                filterOptions={filterOptionsForOffice}
                                renderOption={(props, option) => {
                                    return (
                                        <li {...props} key={option.id}>
                                            {option.officeName}
                                        </li>
                                    );
                                }}
                                onChange={(e, value) => {
                                    setFieldValue("officeId", value?.id || "");
                                }}
                                onOpen={handleBlur}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        fullWidth
                                        id="officeId"
                                        name="officeId"
                                        label="Office"
                                        error={Boolean(errors.officeId)}
                                        value={officeId}
                                        helperText={touched.officeId ? errors.officeId : ""}
                                    />
                                )}
                            />
                        }
                    </Grid>
                    <Grid item xs={12}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    name="active"
                                    color="secondary"
                                    checked={active || false}
                                    onChange={(ev, checked) => { setFieldValue('active', checked); }}
                                />
                            }
                            label="Active"
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    name="newsletter"
                                    color="secondary"
                                    checked={newsletter||false}
                                    onChange={(ev, checked) => { setFieldValue('newsletter', checked); }}
                                />
                            }
                            label="I would like to receive the Agrecalc Newsletter"
                        />
                    </Grid>
                    <Stack spacing={2} sx={{ marginLeft: 'auto', marginTop: 3 }} direction="row" >
                        <Button variant="outlined" sx={{ left: 'auto', textTransform: 'none' }}
                            onClick={handleBackResponse}>
                            Back
                        </Button>
                        <Button variant="outlined" sx={{ textTransform: 'none' }}
                            onClick={(e) => {
                                e.stopPropagation();
                                setModalOpen(true);
                            }}>
                            Cancel
                        </Button>
                        {mode === EDIT && <Button variant="outlined" sx={{ textTransform: 'none' }}
                            onClick={(e) => {
                                e.stopPropagation();
                                setDeleteModalOpen(true);
                            }}>
                            Delete
                        </Button>}
                        <Button type="submit" variant="contained" sx={{ textTransform: 'none' }}>
                            Save
                        </Button>
                    </Stack>
                </Grid>
                <CancelModal isOpen={modalOpen} handleResponse={handleCancelModalResponse} />
                <DeleteModal
                    isOpen={deleteModalOpen}
                    handleResponse={handleDeleteModalResponse}
                    value='Are you sure you want to delete this User?' />
                <AgcAlert onClose={onAlertClose} />
            </Box>
    )
}

export default AccountForm